
import { Component, Vue } from 'vue-property-decorator';
import {
  dismissDialog, getDialogComponent, getDialogProps, isDialogVisible,
} from '~/plugins/dialog/state';

@Component
export default class GlobalDialog extends Vue {
  get component() {
    return getDialogComponent();
  }

  get props() {
    return getDialogProps();
  }

  get isVisible() {
    return isDialogVisible();
  }

  dismissDialog() {
    dismissDialog();
  }
}
